export enum InputValidationNumbers {
  inputMin = 3,
  inputMax = 65,
  inputPhoneMin = 10,
  inputPhoneMax = 15,
  inputYearMin = 1000,
  inputYearMax = 9999,
}
